import { QUERY_KEYS } from '@/api/queryKeys';
import { LoadLaneModel } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { loadlanes } from '../LoadLanes';

const getLoadLanesErrorMessage = (message: unknown) => {
  if (typeof message === 'string') return message;
  if (
    message &&
    typeof message === 'object' &&
    'Message' in message &&
    typeof (message as { Message?: string }).Message === 'string'
  ) {
    return (message as { Message: string }).Message;
  }
  return 'Failed to load lanes';
};

export const useLoadLanes = (siteId?: number, customerId?: number) =>
  useQuery({
    queryKey: [QUERY_KEYS.loadLanes, siteId, customerId],
    queryFn: async () => {
      const response = await loadlanes.getLoadLanes(siteId!, customerId!);

      if (
        (response as { errorResponse?: boolean }).errorResponse ||
        !response.success
      ) {
        throw new Error(getLoadLanesErrorMessage(response.message));
      }

      return (response.data ?? {
        locationLanes: [],
        movements: [],
      }) as LoadLaneModel;
    },
    enabled: Boolean(siteId && customerId),
  });
